function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  "data-name": "Capa 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M339.33 97.6L354 83 271 0l-14.62 14.65 34.15 34.15-18.06 18.07-21-21-23.79 23.79-13.15-13.16-14.65 14.65 82.95 82.95 14.65-14.65-13.16-13.15 23.79-23.79-21-21 18.06-18.06zM257.55 158.2L127.29 288.46l-39.03-8.09-73.61 73.61L0 339.33l73.15-73.15-8.08-39.03 24.16-24.17 17.93 17.92 14.65-14.65-17.92-17.92 21.88-21.88 25.73 25.74 14.65-14.66-25.74-25.73 21.88-21.88 17.93 17.93 14.64-14.65-17.92-17.93 18.84-18.84 61.77 61.77z"
})));

var SvgServiceFluShot = function SvgServiceFluShot(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 353.98 353.98",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgServiceFluShot, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/service-flu-shot.c660baba.svg";
export { ForwardRef as ReactComponent };